import { render } from "./DrawerHorario.vue?vue&type=template&id=5414cd42&ts=true"
import script from "./DrawerHorario.vue?vue&type=script&lang=ts"
export * from "./DrawerHorario.vue?vue&type=script&lang=ts"

import exportComponent from "/tmp/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__